<template>
  <div class="mt-1 relative mb-1">
    <span class="opacity-70 mt-2.5 text-[14px] text-yellow-200">{{
      message
    }}</span>
    <a href="javascript:void 0" class="hover:underline" @click="editWatchface"
      >修改智能类型</a
    >
  </div>
</template>

<script lang="ts" setup>
import { useWatchfaceStore } from '@/store/use-watchface-store';
import { emitter, EventType } from '@/utils/emitter.utils';

defineProps({
  message: {
    type: String,
    required: true
  }
});

const watcfaceStore = useWatchfaceStore();

const editWatchface = () => {
  emitter.emit(EventType['modal:watchface-manage'], {
    path: watcfaceStore.path,
    mode: 'edit'
  });
};
</script>
